import React from "react";
import Reveal from "../Reveal";
import Eyebrow from "../Eyebrow";

/**
 * Reusable section heading component with eyebrow, title, and description.
 *
 * @param {Object} props - Component props.
 * @param {string} props.eyebrow - Small text above the title.
 * @param {React.ReactNode} props.title - The main heading text.
 * @param {string} [props.description] - Supporting text below the title.
 * @param {boolean} [props.centered=false] - Whether to center the text.
 * @param {string} [props.className] - Additional CSS classes.
 * @param {string} [props.variant] - Reveal animation variant.
 * @returns {JSX.Element} Section heading component.
 */
const SectionHeading = ({
    eyebrow,
    title,
    description,
    centered = false,
    className = "",
    variant
}) => (
    <Reveal variant={variant}>
        <div className={`section-heading ${centered ? "section-heading--centered" : ""} ${className}`}>
            {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
            {title && <h2 className="section-heading__title">{title}</h2>}
            {description && <p className="section-heading__intro">{description}</p>}
        </div>
    </Reveal>
);

export default SectionHeading;
